import { useMutation as s } from "react-query";
import { useEnvironment as r } from "../../../../../features/common/hooks/environment/useEnvironment.js";
import { ScopeAdapter as o } from "../../../../../features/api/models/scope/scope.adapter.js";
import { getAdapter as a } from "../../../../../features/api/adapter.js";
function m() {
  const {
    backendBaseUrl: t
  } = r();
  return s(
    async (e) => (await fetch(`${t}/shop-service/availability/timeslot/`, {
      method: "post",
      body: JSON.stringify({
        date: e.date,
        service_type: e.serviceType,
        scope: a(o).serialize(e.scope),
        address: e.address
      })
    })).json()
  );
}
export {
  m as default
};
//# sourceMappingURL=useRestaurantHours.js.map
